import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { FaLanguage, FaRegHandPointRight } from "react-icons/fa";
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { CgChanel } from 'react-icons/cg'
import { addDataAPI } from '../../utils/api';
import ContentWrapper from '../../components/contentwrapper/ContentWrapper';
import { GiMushroomGills } from 'react-icons/gi';


const AddProblem = () => {
    const navigate = useNavigate();
    const [values, setUserValue] = useState({});
    const [validated, setValidated] = useState(false);

    const subadminid = localStorage.getItem('subadmindata');
    
    useEffect(() => {
        if (subadminid) {
            navigate('/add-subadmin-problem');
        }
        else {
            navigate("/");
        }
    }, [subadminid]);

    const handleInputs = async (e) => {
        setUserValue({
            ...values,
            [e.target.name]: e.target.value,
        });
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            const datavalue = {
                problem_name:values?.problem_name,
                subadmin_id:subadminid,
            };
            addDataAPI('sub-admin-add-problem', datavalue).then((res) => {
                if (res.data.status === 1) {
                    navigate("/all-subadmin-problem");
                    toast.success("Problem has been added successfully!!")
                }
                else if (res.data.status === 2) {
                    toast.warning("Problem already Exit!!")
                }
                else {
                    toast.warning("Check your connection!!");
                }
            })
        }
        setValidated(true);
    }
    return (
        <div className="addCompany">
            <Helmet>
                <title>SATKARTAR:SUB ADMIN::ADD Problem</title>
            </Helmet>

            <ContentWrapper>
                <div className="col-xl-6">
                    <div className="card border-top border-0 border-4 border-danger">
                        <div className="card-body formbody">
                            <div className="card-title d-flex align-items-center">
                                <div>
                                    <GiMushroomGills className="formIcons" />
                                </div>
                                <h5 className="mb-0 text-danger">ADD Problem</h5>
                            </div>
                            <hr />
                            <Form noValidate validated={validated} method="POST" onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="12" controlId="validationChanelName">
                                        <Form.Label>Problem Name</Form.Label>
                                        <InputGroup hasValidation>
                                            <InputGroup.Text id="inputGroupPrepend"><GiMushroomGills /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Problem Name"
                                                aria-describedby="inputGroupPrepend"
                                                required
                                                name="problem_name"
                                                onChange={handleInputs}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Please provide a valid problem name.
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                    
                                </Row>
                                <Button type="submit">Add</Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default AddProblem